import React, { useState } from 'react';

const ServicesSection = () => {
  const [activeTab, setActiveTab] = useState('chatbot');

  const services = {
    chatbot: {
      title: '챗봇 개발 서비스',
      description: '비즈니스에 특화된 맞춤형 AI 챗봇 개발로 고객 응대 자동화 및 효율 향상',
      features: [
        '자연스러운 대화형 인터페이스',
        '고객 맞춤 학습 및 데이터 통합',
        '다국어 지원 및 24/7 응대 가능',
        '기존 시스템과의 원활한 통합',
        '자동 학습을 통한 지속적인 개선'
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    },
    integration: {
      title: 'AI 솔루션 통합',
      description: '기존 시스템에 Generative AI 도입 컨설팅 및 통합으로 업무 프로세스 혁신',
      features: [
        'ERP, CRM 등 기존 시스템과의 원활한 통합',
        '데이터 보안을 고려한 AI 도입 전략',
        '단계별 구현 및 성과 측정',
        'API 및 SDK를 통한 유연한 확장성',
        '사용자 중심 UI/UX 설계'
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
        </svg>
      )
    },
    consulting: {
      title: 'AI 전략 컨설팅',
      description: '기업별 AI 활용 전략 수립부터 모델 튜닝까지 종합 컨설팅 제공',
      features: [
        'AI 도입 로드맵 수립',
        '산업별 맞춤형 AI 솔루션 제안',
        'ROI 분석 및 비즈니스 임팩트 예측',
        'AI 윤리 및 규제 준수 가이드',
        '데이터 전략 및 인프라 설계'
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    content: {
      title: 'AI 콘텐츠 생성',
      description: '텍스트, 이미지, 비디오 등 다양한 형태의 고품질 콘텐츠 자동 생성 서비스',
      features: [
        '마케팅 콘텐츠 자동 생성',
        '브랜드 톤앤매너에 맞춘 커스터마이징',
        '다양한 포맷(블로그, SNS, 이메일 등) 지원',
        '이미지 및 동영상 콘텐츠 생성',
        '대규모 콘텐츠 일괄 생성 가능'
      ],
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      )
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            서비스
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            혁신적인 <span className="text-primary">AI 솔루션</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            GenAI Dev는 Generative AI 기술을 활용하여 기업의 다양한 니즈에 맞춘 솔루션을 제공합니다.
            챗봇, 시스템 통합, 전략 컨설팅, 콘텐츠 생성까지 AI 기반 서비스로 비즈니스 혁신을 지원합니다.
          </p>
        </div>

        {/* 서비스 탭 */}
        <div className="flex flex-wrap justify-center mb-10 gap-2">
          {Object.keys(services).map((key) => (
            <button
              key={key}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${
                activeTab === key
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
              onClick={() => setActiveTab(key)}
            >
              {services[key].title}
            </button>
          ))}
        </div>

        {/* 선택된 서비스 상세 */}
        <div className="bg-light rounded-2xl p-8 md:p-10 shadow-md">
          <div className="flex flex-col md:flex-row gap-10">
            <div className="md:w-1/2">
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6 text-primary">
                {services[activeTab].icon}
              </div>
              <h3 className="text-2xl font-bold text-dark mb-4">{services[activeTab].title}</h3>
              <p className="text-gray-600 mb-6">{services[activeTab].description}</p>
              
              <h4 className="font-bold text-dark mb-4">주요 특징</h4>
              <ul className="space-y-3">
                {services[activeTab].features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <div className="mt-8">
                <a 
                  href="#contact"
                  className="inline-block bg-primary text-white px-6 py-3 rounded-md font-medium hover:bg-primary/90 transition-colors"
                >
                  상담 요청하기
                </a>
              </div>
            </div>
            
            <div className="md:w-1/2 bg-white rounded-xl shadow-sm p-6">
              {activeTab === 'chatbot' && (
                <div className="bg-light rounded-lg p-4 h-full">
                  <h4 className="font-bold text-dark mb-4">AI 챗봇 사례</h4>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mr-3 flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                        </svg>
                      </div>
                      <div className="bg-white p-3 rounded-lg shadow-sm">
                        <p className="text-gray-700">고객: 주문한 제품의 배송 현황을 알고 싶어요.</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mr-3 flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                        </svg>
                      </div>
                      <div className="bg-white p-3 rounded-lg shadow-sm">
                        <p className="text-gray-700">챗봇: 고객님의 주문 번호를 알려주시면 배송 현황을 확인해 드리겠습니다.</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start justify-end">
                      <div className="bg-primary/10 p-3 rounded-lg">
                        <p className="text-gray-700">ORDER-12345</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mr-3 flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                        </svg>
                      </div>
                      <div className="bg-white p-3 rounded-lg shadow-sm">
                        <p className="text-gray-700">챗봇: ORDER-12345 주문은 현재 배송 중이며, 내일 오후 3시 경 도착 예정입니다. 배송 기사님 연락처는 010-1234-5678입니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {activeTab === 'integration' && (
                <div className="h-full flex flex-col justify-center">
                  <h4 className="font-bold text-dark mb-4">시스템 통합 구조도</h4>
                  <div className="bg-light p-4 rounded-lg mb-4">
                    <div className="flex justify-between items-center mb-6">
                      <div className="w-24 h-16 bg-primary/10 rounded flex items-center justify-center text-primary font-medium">
                        CRM
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                      </svg>
                      <div className="w-24 h-16 bg-primary/10 rounded flex items-center justify-center text-primary font-medium">
                        ERP
                      </div>
                    </div>
                    
                    <div className="w-full h-20 bg-primary/20 rounded-lg mb-6 flex items-center justify-center text-primary font-medium">
                      GenAI 통합 계층
                    </div>
                    
                    <div className="grid grid-cols-3 gap-4">
                      <div className="h-16 bg-accent/10 rounded flex items-center justify-center text-accent font-medium text-sm">
                        고객 분석
                      </div>
                      <div className="h-16 bg-accent/10 rounded flex items-center justify-center text-accent font-medium text-sm">
                        자동화 워크플로우
                      </div>
                      <div className="h-16 bg-accent/10 rounded flex items-center justify-center text-accent font-medium text-sm">
                        AI 리포트
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm">
                    GenAI Dev의 통합 솔루션은 기존 시스템과 원활하게 연동되어 데이터 흐름을 최적화하고, 
                    AI 기반 인사이트를 제공하여 업무 효율성을 크게 향상시킵니다.
                  </p>
                </div>
              )}
              
              {activeTab === 'consulting' && (
                <div className="h-full">
                  <h4 className="font-bold text-dark mb-4">AI 전략 컨설팅 프로세스</h4>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center mr-3 flex-shrink-0 font-bold">
                        1
                      </div>
                      <div>
                        <h5 className="font-bold text-dark">현황 분석</h5>
                        <p className="text-gray-600 text-sm">기업의 현재 프로세스, 데이터 환경, AI 준비도 평가</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center mr-3 flex-shrink-0 font-bold">
                        2
                      </div>
                      <div>
                        <h5 className="font-bold text-dark">기회 식별</h5>
                        <p className="text-gray-600 text-sm">AI 도입을 통한 가치 창출 가능 영역 도출</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center mr-3 flex-shrink-0 font-bold">
                        3
                      </div>
                      <div>
                        <h5 className="font-bold text-dark">로드맵 수립</h5>
                        <p className="text-gray-600 text-sm">단계별 AI 구현 계획 및 ROI 예측</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center mr-3 flex-shrink-0 font-bold">
                        4
                      </div>
                      <div>
                        <h5 className="font-bold text-dark">파일럿 프로젝트</h5>
                        <p className="text-gray-600 text-sm">검증된 영역에서의 소규모 AI 구현 및 효과 측정</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center mr-3 flex-shrink-0 font-bold">
                        5
                      </div>
                      <div>
                        <h5 className="font-bold text-dark">확장 및 최적화</h5>
                        <p className="text-gray-600 text-sm">성공적인 파일럿을 기반으로 전사적 확장 지원</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {activeTab === 'content' && (
                <div className="h-full">
                  <h4 className="font-bold text-dark mb-4">AI 콘텐츠 생성 샘플</h4>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="bg-gray-100 rounded-lg p-3 aspect-square flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="bg-gray-100 rounded-lg p-3 aspect-square flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  </div>
                  
                  <div className="bg-light rounded-lg p-4 mb-4">
                    <h5 className="font-bold text-dark text-sm mb-2">AI 생성 마케팅 텍스트 예시</h5>
                    <p className="text-gray-600 text-sm">
                      "디지털 혁신의 시대, Generative AI와 함께 비즈니스의 새로운 가능성을 열어보세요. 
                      데이터에서 인사이트를, 인사이트에서 성장을 이끌어내는 GenAI Dev의 솔루션으로 
                      경쟁에서 한 발 앞서 나가세요."
                    </p>
                  </div>
                  
                  <div className="text-center bg-light rounded-lg p-4">
                    <h5 className="font-bold text-dark text-sm mb-2">생성 속도</h5>
                    <div className="flex justify-center items-center gap-3">
                      <span className="text-gray-600 text-sm">블로그 포스트 (500단어)</span>
                      <span className="text-primary font-bold">2분 이내</span>
                    </div>
                    <div className="flex justify-center items-center gap-3">
                      <span className="text-gray-600 text-sm">SNS 포스트 10개</span>
                      <span className="text-primary font-bold">5분 이내</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* 산업별 적용 사례 */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-dark mb-10 text-center">
            <span className="text-primary">산업별</span> 적용 사례
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
              </div>
              <h4 className="font-bold text-dark mb-2">리테일</h4>
              <p className="text-gray-600 text-sm mb-4">
                개인화된 쇼핑 경험, 재고 최적화, 가상 피팅룸, 고객 서비스 자동화
              </p>
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500">효율성 향상</span>
                <span className="text-xs font-medium text-primary">35%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1">
                <div className="bg-primary h-1.5 rounded-full" style={{width: '35%'}}></div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h4 className="font-bold text-dark mb-2">금융</h4>
              <p className="text-gray-600 text-sm mb-4">
                위험 평가, 부정 거래 탐지, 자동화된 고객 상담, 맞춤형 금융 상품 추천
              </p>
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500">위험 감소</span>
                <span className="text-xs font-medium text-primary">42%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1">
                <div className="bg-primary h-1.5 rounded-full" style={{width: '42%'}}></div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h4 className="font-bold text-dark mb-2">제조업</h4>
              <p className="text-gray-600 text-sm mb-4">
                예측적 유지보수, 품질 관리, 공급망 최적화, 생산 프로세스 자동화
              </p>
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500">다운타임 감소</span>
                <span className="text-xs font-medium text-primary">55%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1">
                <div className="bg-primary h-1.5 rounded-full" style={{width: '55%'}}></div>
              </div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h4 className="font-bold text-dark mb-2">헬스케어</h4>
              <p className="text-gray-600 text-sm mb-4">
                의료 영상 분석, 환자 데이터 관리, 맞춤형 치료 계획, 원격 진료 지원
              </p>
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500">진단 정확도</span>
                <span className="text-xs font-medium text-primary">38%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1">
                <div className="bg-primary h-1.5 rounded-full" style={{width: '38%'}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 